import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enModals from './locales/en/modals.json';
import enVoices from './locales/en/voices.json';
import enGeneral from './locales/en/general.json';
import enForm from './locales/en/form.json';
import enTabs from './locales/en/tabs.json';

import ruModals from './locales/ru/modals.json';
import ruVoices from './locales/ru/voices.json';
import ruGeneral from './locales/ru/general.json';
import ruForm from './locales/ru/form.json';
import ruTabs from './locales/ru/tabs.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        modals: enModals,
        voices: enVoices,
        general: enGeneral,
        form: enForm,
        tabs: enTabs,
      },
      ru: {
        modals: ruModals,
        voices: ruVoices,
        general: ruGeneral,
        form: ruForm,
        tabs: ruTabs,
      },
    },
    lng: 'ru',
    fallbackLng: 'en',
    ns: ['modals', 'voices', 'general', 'form', 'tabs'],
    defaultNS: 'general',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;